<template>
  <i class="tm-row">
    <i class="-visual" :class="{ '-highlighted': highlightVisualTrack }" />

    <template v-if="shouldShow_TrackLayerTranscript">
      <i class="-text" />
      <i class="wticon wticon-camera2" />
      <i class="wticon wticon-Transcript" />
    </template>

    <template v-if="shouldShow_TrackLayerAudio">
      <i class="-audio" :class="{ '-highlighted': highlightAudioTrack }" />
      <i class="wticon wticon-mic" />
    </template>

    <tm-ticks :ticks="ticks" />
  </i>
</template>

<script>
import { rulerTimeFormat } from '../../api/tapi';
import tmTicks from './tmTicks.vue';
import fg from '#/libs/FrameGrid';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'tm-row',
  components: { tmTicks },

  props: {
    row: { type: Object },
  },

  computed: {
    ...mapState('timemachine', {
      MODE_VISUAL_DND: (state) => state.MODE.VISUAL_DND,
      MODE_AUDIO_DND: (state) => state.MODE.AUDIO_DND,
    }),
    ...mapGetters('timemachine', [
      'shouldShow_TrackLayerAudio',
      'shouldShow_TrackLayerTranscript',
    ]),

    ticks() {
      const step =
        this.row.gridDuration <= 1
          ? fg.SPF
          : this.row.gridDuration <= 120
          ? 1
          : this.row.gridDuration <= 300
          ? 5
          : 60;
      const stepMark =
        this.row.gridDuration <= 10
          ? 1
          : this.row.gridDuration <= 120
          ? 5
          : this.row.gridDuration <= 300
          ? 10
          : 300;
      const rv = [];
      for (let i = 0, I = this.row.gridDuration; i <= I; i += step) {
        const tick = {};
        if (fg.trunc(i) % stepMark === 0) {
          tick.time = rulerTimeFormat(this.row.gridStartTime + fg.trunc(i));
        }
        rv.push(tick);
      }

      return rv;
    },

    highlightVisualTrack() {
      return this.MODE_VISUAL_DND;
    },

    highlightAudioTrack() {
      return this.MODE_AUDIO_DND;
    },
  },
};
</script>

<style lang="scss">
.tm-grid > .tm-row {
  --icon-size: 16px;

  display: flex;
  flex-direction: column;
  flex: 0 1 auto;
  align-self: stretch;
  position: relative;
  height: var(--tm-pxRowHeight);

  > .-visual {
    height: var(--tm-pxAssetHeight);
    margin-top: var(--tm-pxRowBlankTop);
    background-color: var(--tm-rulerBackground);
    background-image: url('https://dp4stoslb9jdl.cloudfront.net/Resources/studio/img/vmTimeline/movie-film-3a.png');
    border: 1px solid var(--tm-rulerBorder);
  }

  > .-text {
    height: var(--tm-pxTranscriptTrackH);
  }

  > .-audio {
    height: var(--tm-pxAudioTrackH);
    //margin-top: var(--tm-pxTranscriptTrackH);
    background-color: var(--tm-audioTrackBackground);
  }

  > .-highlighted {
    background-color: var(--tm-higlightedTrackBackground);
  }

  > .wticon {
    position: absolute;
    left: -26px;
    color: rgba(0, 0, 0, 0.3);
    font-size: var(--icon-size);
  }

  > .wticon-camera2 {
    top: calc(
      var(--tm-pxRowBlankTop) + var(--tm-pxAssetHeight) / 2 - var(--icon-size) /
        2
    );
  }

  > .wticon-Transcript {
    top: calc(
      var(--tm-pxRowBlankTop) + var(--tm-pxAssetHeight) +
        var(--tm-pxTranscriptTrackH) / 2 - var(--icon-size) / 2
    );
  }

  > .wticon-mic {
    top: calc(
      var(--tm-pxAudioTopOffset) + var(--tm-pxAudioTrackH) / 2 -
        var(--icon-size) / 2
    );
  }
}
</style>
